const StatusRadio = {
  parts: ['container', 'control', 'checkedDot', 'label'],
  baseStyle: {
    container: {
      bg: 'blueLight',
      borderRadius: 'full',
      px: 3,
      py: 2,
      cursor: 'pointer',
      userSelect: 'none',
      transition: 'background-color .2s ease, color .2s ease',
    },
    control: {
      boxSize: '14px',
      borderRadius: 'full',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'WPPgray.200',
      bg: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    checkedDot: {
      boxSize: '6px',
      borderRadius: 'full',
      bg: 'graphite.400',
      transition: 'opacity .2s ease, background-color .2s ease',
    },
    label: {
      mb: 0,
      fontSize: 'sm',
      fontWeight: 'semibold',
    },
  },
  variants: {
    statusGroups: {},
  },
  sizes: {
    sm: {
      label: { fontSize: 'sm' },
    },
    md: {
      label: { fontSize: 'md' },
    },
  },
  defaultProps: {
    variant: 'statusGroups',
    size: 'sm',
  },
};

export default StatusRadio;
